// extracted by mini-css-extract-plugin
module.exports = {"Tab":"ContentSelector_Tab__UyXHV","Active":"ContentSelector_Active__ScCBJ"};